import { useEffect } from 'react'
import { useLocation, useNavigationType } from 'react-router-dom'

/**
 * Scroll and focus management for client-side navigation.
 *
 * - Back/forward (POP) is left to the browser's own scroll restoration.
 * - A hash target is scrolled into view rather than jumping to the top.
 * - Otherwise the new page starts at the top, and focus moves to <main> so
 *   screen-reader and keyboard users land on the new content instead of
 *   staying where the old page left them.
 */
export function RouteChangeEffects() {
  const { pathname, hash } = useLocation()
  const navigationType = useNavigationType()

  useEffect(() => {
    if (navigationType === 'POP') return

    if (hash) {
      const target = document.querySelector(hash)
      if (target) {
        target.scrollIntoView({ block: 'start' })
        return
      }
    }

    window.scrollTo(0, 0)

    const main = document.getElementById('main')
    // Focus without a second scroll — scrollTo above already positioned us.
    main?.focus({ preventScroll: true })
  }, [pathname, hash, navigationType])

  return null
}
